<template>
  <v-container fill-height fluid grid-list-xl>

    <v-flex>
      <app-upsert title='Utilities' :config='config'>

      </app-upsert>

    </v-flex>

  </v-container>
</template>

<script>

import config from './config.js'

export default {
  data () {
    return { config }
  }
}
</script>
